// extracted by mini-css-extract-plugin
export var actions = "_mf-d";
export var benefitCard = "_mf-a";
export var benefitIcon = "_mf-b";
export var benefitLabel = "_mf-c";
export var benefits = "_mf-9";
export var bodyText = "_mf-8";
export var closeButton = "_mf-2";
export var content = "_mf-3";
export var eyebrow = "_mf-4";
export var heading = "_mf-5";
export var image = "_mf-f";
export var imagePanel = "_mf-e";
export var modal = "_mf-0";
export var shell = "_mf-1";
export var title = "_mf-6";
export var titleOffer = "_mf-7";